<template>
  <form-layout :label="label">
    <read-only-input :value="value" />
  </form-layout>
</template>

<script>
import FormLayout from '@/views/templates/FormLayout'
import ReadOnlyInput from "@/views/atoms/inputs/ReadOnlyInput";

export default {
  name: "TextBrowseItem",
  components: {
    FormLayout,
    ReadOnlyInput,
  },
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, null],
      required: true
    }
  },
}
</script>
